import { Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useDocumentPreview } from 'app/domains/documents';
import { DeleteDocumentDialog, DownloadDocumentDialog, MoveDialog, ROOT } from 'app/domains/filesystem';
import { EntryKind } from 'shared/domains/apollo/generated/types';
export function DocumentActionMenu(props) {
    const { cacheId, entityId, parentId, typename } = props;
    const history = useHistory();
    const { previewDocument } = useDocumentPreview();
    const [actionDialog, setActionDialog] = useState();
    const menuItemClickHandler = (dialogType) => () => {
        setActionDialog(dialogType);
    };
    const handlePreview = () => previewDocument(entityId);
    const handleOpenInFolder = () => {
        if (parentId && parentId !== ROOT) {
            history.push(`/files/${parentId}`);
        }
        else {
            history.push('/files');
        }
    };
    const closeDialog = () => setActionDialog(undefined);
    const handleUpdate = (cache) => {
        cache.modify({
            id: cache.identify({ id: cacheId, __typename: typename }),
            fields(_, { DELETE }) {
                return DELETE;
            },
        });
    };
    return (<Fragment>
      <Menu.Root align="end" target={<IconButton appearance="ghost" size="xs">
            <Falcon icon="ellipsis-h"/>
          </IconButton>}>
        <Menu.Item onClick={handlePreview}>
          <Falcon icon="file"/>
          <Trans comment="Search Table Row Context Menu item - Preview">Preview</Trans>
        </Menu.Item>
        <Menu.Item onClick={menuItemClickHandler('download')}>
          <Falcon icon="download"/>
          <Trans comment="Search Table Row Context Menu item - Download">Download</Trans>
        </Menu.Item>
        <Menu.Item onClick={handleOpenInFolder}>
          <Falcon icon="folder-open"/>
          <Trans comment="Search Table Row Context Menu item - Open in folder">Open in folder</Trans>
        </Menu.Item>
        <Menu.Item onClick={menuItemClickHandler('moveToFolder')}>
          <Falcon icon="folder"/>
          <Trans comment="Search Table Row Context Menu item - Move to folder">Move to folder</Trans>
        </Menu.Item>
        <Menu.Item onClick={menuItemClickHandler('delete')}>
          <Falcon icon="trash"/>
          <Trans comment="Search Table Row Context Menu item - Delete">Delete</Trans>
        </Menu.Item>
      </Menu.Root>

      {actionDialog === 'download' && <DownloadDocumentDialog id={entityId} onClose={closeDialog}/>}

      {actionDialog === 'moveToFolder' && (<MoveDialog type={EntryKind.Document} payload={{ id: entityId }} parentId={parentId} onClose={closeDialog}/>)}

      {actionDialog === 'delete' && (<DeleteDocumentDialog id={entityId} onClose={closeDialog} onUpdate={handleUpdate}/>)}
    </Fragment>);
}
